module.exports = __webpack_public_path__ + "img/8.dd23bcaa.jpg";